import React from "react";
import { t } from "i18next";
import { CURRENCY_TYPE,STRING_CONSTANT } from "../../../constants/constants";

const FeesTable = (props) => {
  const { title, feesList, isMandatoryRegistration, conferenceDetails ,aed } =
    props;

  const checkFees = (feeToPay, discount) => {
    return feeToPay > 0 ? (feeToPay * (1-discount/100)).toFixed(2) : t("free");
  };

  const isAED =
    conferenceDetails?.currencyType === CURRENCY_TYPE.AED ||
    conferenceDetails?.currencyType === CURRENCY_TYPE.BOTH;
  const isUSD =
    conferenceDetails?.currencyType === CURRENCY_TYPE.USD ||
    conferenceDetails?.currencyType === CURRENCY_TYPE.BOTH;
  
  
  return (
    <>
       {feesList?.some(fee =>
         (isAED && fee?.regularFeeAED > 0) ||
         (isUSD && fee?.regularFeeUSD > 0)
       ) && (
         <>
          <h5 className="mb-3">{title}</h5>
          <table className="table table-bordered mb-3">
            <thead>
              <tr>
                <th>{t("registration-type")}</th>
                {isAED && <th>{t("regular-fees-aed")}</th>}
                {isUSD && <th>{t("regular-fees-usd")}</th>}
                {isAED && isMandatoryRegistration && (
                  <th>{t("early-bird-fees-aed")}</th>
                )}
                {isUSD && isMandatoryRegistration && (
                  <th>{t("early-bird-fees-usd")}</th>
                )}
              </tr>
            </thead>
            <tbody>
              {feesList &&
                feesList.map((fee, index) => (
                  <tr key={index}>
                    <td>{fee?.subscriptionKey}</td>
                    {isAED && <td>{checkFees(fee?.regularFeeAED, fee?.discount)}</td>}
                    {isUSD && <td>{checkFees(fee?.regularFeeUSD, fee?.discount)}</td>}
                    {isAED && isMandatoryRegistration && (
                      <td>{checkFees(fee?.earlyBirdFeeAED, fee?.discount)}</td>
                    )}
                    {isUSD && isMandatoryRegistration && (
                      <td>{checkFees(fee?.earlyBirdFeeUSD, fee?.discount)}</td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
         <p className="mb-5">
                <strong>{`${t("note")} ${STRING_CONSTANT.COLON} `}</strong>
                <span>
                  {`${t("note-for-card-charges")} ${t("conversion-rate")} 1 ${t(
                    "usd"
                  )} ${STRING_CONSTANT.EQUAL} ${aed} ${t("aed")}`}
                </span>
              </p>
        </>
      )}
    </>
  );
};

export default FeesTable;
